export default [
    {
        path: '/coffee',
        name: 'coffee',
        meta: {
            title: '咖啡领取'
        },
        component: () => import('@/views/coffee')
    },
]